export default __webpack_public_path__ + "static/media/background.219a0c14.png";